export var M365ThemeKind;
(function (M365ThemeKind) {
    M365ThemeKind[M365ThemeKind["FabricDefaultTheme"] = 0] = "FabricDefaultTheme";
    M365ThemeKind[M365ThemeKind["M365Dark"] = 1] = "M365Dark";
    M365ThemeKind[M365ThemeKind["M365Light"] = 2] = "M365Light";
    M365ThemeKind[M365ThemeKind["M365LightWithContrast"] = 3] = "M365LightWithContrast";
    M365ThemeKind[M365ThemeKind["TeamsLight"] = 4] = "TeamsLight";
    M365ThemeKind[M365ThemeKind["TeamsDark"] = 5] = "TeamsDark";
    M365ThemeKind[M365ThemeKind["PPACLight"] = 6] = "PPACLight";
    M365ThemeKind[M365ThemeKind["PPACDark"] = 7] = "PPACDark";
    M365ThemeKind[M365ThemeKind["WindowsLight"] = 8] = "WindowsLight";
    M365ThemeKind[M365ThemeKind["WindowsDark"] = 9] = "WindowsDark";
    M365ThemeKind[M365ThemeKind["ExcelDarkTheme"] = 10] = "ExcelDarkTheme";
    M365ThemeKind[M365ThemeKind["ExcelLightTheme"] = 11] = "ExcelLightTheme";
    M365ThemeKind[M365ThemeKind["OfficeDarkTheme"] = 12] = "OfficeDarkTheme";
    M365ThemeKind[M365ThemeKind["OfficeLightTheme"] = 13] = "OfficeLightTheme";
    M365ThemeKind[M365ThemeKind["OneNoteDarkTheme"] = 14] = "OneNoteDarkTheme";
    M365ThemeKind[M365ThemeKind["OneNoteLightTheme"] = 15] = "OneNoteLightTheme";
    M365ThemeKind[M365ThemeKind["PowerPointDarkTheme"] = 16] = "PowerPointDarkTheme";
    M365ThemeKind[M365ThemeKind["PowerPointLightTheme"] = 17] = "PowerPointLightTheme";
    M365ThemeKind[M365ThemeKind["VisioDarkTheme"] = 18] = "VisioDarkTheme";
    M365ThemeKind[M365ThemeKind["VisioLightTheme"] = 19] = "VisioLightTheme";
    M365ThemeKind[M365ThemeKind["WordDarkTheme"] = 20] = "WordDarkTheme";
    M365ThemeKind[M365ThemeKind["WordLightTheme"] = 21] = "WordLightTheme";
})(M365ThemeKind || (M365ThemeKind = {}));
// TODO: DI this thing.
// NOTE: keep in same order as above, until above is deprecated.
export var themeNameToEnum = [
    'FabricDefaultTheme',
    'M365Dark',
    'M365Light',
    'M365LightWithContrast',
    'TeamsLight',
    'TeamsDark',
    'PPACLight',
    'PPACDark',
    'WindowsLight',
    'WindowsDark',
    'ExcelDarkTheme',
    'ExcelLightTheme',
    'OfficeDarkTheme',
    'OfficeLightTheme',
    'OneNoteDarkTheme',
    'OneNoteLightTheme',
    'PowerPointDarkTheme',
    'PowerPointLightTheme',
    'VisioDarkTheme',
    'VisioLightTheme',
    'WordDarkTheme',
    'WordLightTheme'
].map(function (n) { return n.toLowerCase(); });
